import { message } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { getFormSignature, updateSignatureState } from '../../../services/exam';

const useHandleSignature = (admissionPatientExamId) => {
  const [loading, setLoading] = useState({
    saved: false,
    form: false,
  });
  const [formData, setFormData] = useState({});


  const handleLoading = (signal, status) => {
    if (signal === 'start') {
      setLoading(loading => ({ ...loading, [status]: true }));
    } else {
      setLoading(loading => ({ ...loading, [status]: false }));
    }
  };

  const handleMessage = (content, state) => {
    if (state === 'success') {
      message.success({
        content: `Exito al ${content} el examen`,
        style: {
          marginTop: '40vh',
        },
      });
    } else {
      message.error({
        content,
        style: {
          marginTop: '40vh',
        },
      });
    }
  };


  const fetchFormSignature = useCallback(async (admissionPatientExamId) => {
    let textState = `Error al traer los datos del formulario`;

    try {
      handleLoading('start', 'form');
      const response = await getFormSignature({ admissionPatientExamId });

      if (response) {
        setFormData(response);
      } else {
        handleMessage(textState, 'error');
      }
      handleLoading('end', 'form');
    } catch (error) {
      console.error(`Error interno: ${error}`);
      textState = `Error interno: ${error}`;
      handleMessage(textState, 'error');
      handleLoading('end', 'form');
    }
  }, []);


  const updateExamSignature = async (querySignature, type) => {
    const text = {
      saved: 'guardar',
      readyToSign: 'guardar y finalizar',
      signed: 'firmar'
    }

    try {
      handleLoading('start', 'saved');

      await updateSignatureState({ ...querySignature, type });

      handleMessage(text[type], 'success');
    } catch (error) {
      console.error(`Error interno: ${error}`);
      handleMessage(`Error interno: ${error}`, 'error');
    } finally {
      handleLoading('end', 'saved');
      await fetchFormSignature(querySignature.admissionPatientExamId);
    }
  };

  const saveExpertFields = async (examData, { sign = false, stateField = null, selectedState = null } = {}) => {
    if (stateField && selectedState) {
      if (!examData.body.expertFields) {
        examData.body.expertFields = [];
      }
      const existingIndex = examData.body.expertFields.findIndex(expertField => expertField.id === stateField.id);
      if (existingIndex >= 0) {
        examData.body.expertFields[existingIndex].result = selectedState;
      } else {
        examData.body.expertFields.push({ ...stateField, result: selectedState });
      }
    }

    handleLoading('start', 'saved');
    await updateSignatureState({ ...examData, type: 'saved' });

    if (sign) {
      await updateSignatureState({ ...examData, type: 'signed' });
      handleMessage('firmar', 'success');
    } else {
      handleMessage('guardar', 'success');
    }

    handleLoading('end', 'saved');
    await fetchFormSignature(examData.admissionPatientExamId);
  };

  useEffect(() => {
    fetchFormSignature(admissionPatientExamId);
  }, [fetchFormSignature, admissionPatientExamId]);


  return {
    loading,
    formData,
    updateExamSignature,
    saveExpertFields,
  };
};

export default useHandleSignature;